<template>
    <div class="container pt-2">
        <PageTitle main="Cargas" sub="Cadastrar, alterar ou deletar Tipos de Cargas" />
        <b-form>
            <input id="carga-id" type="hidden" v-model="carga.id" />
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Titulo:" label-for="carga-titulo">
                        <b-form-input id="carga-titulo" type="text"
                            v-model="carga.titulo"
                            placeholder="Informe o titulo do carga."
                            :class="{ 'inputError': $v.carga.titulo.$error }"
                            class="textInput"
                            @keydown.tab="$v.carga.titulo.$touch"/>
                        <span class="error" v-if="!$v.carga.titulo.required && $v.carga.titulo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.carga.titulo.minLength && $v.carga.titulo.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" @click="save" class="mt-3 botaoInput">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 mt-3 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-cargas" 
                class="text-center table table-sm" 
                :items="cargas.length>0?cargas:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadCarga(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-cargas"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-cargas" 
                class="text-center table table-sm" 
                :items="cargas.length>0?cargas:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadCarga(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-cargas"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'cargas',
    components: { PageTitle },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            carga: {},
            cargas: [],
            fields: [
                { key: 'titulo', label: 'Título', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    validations: {
        carga: {
            titulo: {
                required,
                minLength: minLength(4)
            }
        }
    },
    computed: {
        rows() {
            return this.cargas.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadCargas() {
            const url = `${baseApiUrl}/backend/tipo_carga.php`
            axios.get(url).then(res => {
                this.cargas = res.data
                if(this.cargas.length > 0){
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.carga = {}
            this.loadCargas()
            this.$v.carga.$reset()
        },
        save() {
            this.$v.carga.$touch()
            if(!this.$v.carga.$error){
                const method = this.carga.id ? 'put' : 'post'
                const id = this.carga.id ? `?id=${this.carga.id}` : ''
                axios[method](`${baseApiUrl}/backend/tipo_carga.php${id}`, this.carga)
                    .then(() => {
                        if (method == 'post'){
                            this.$toasted.global.defaultSuccess({ message : 'Carga inserida com sucesso!' })
                        } else {
                            this.$toasted.global.defaultSuccess({ message : 'Carga alterada com sucesso!' })
                        }
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(carga) {
            const sure = confirm("Deseja realmente excluir a carga?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/tipo_carga.php`
                axios.delete(url, { data: carga })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Carga excluída com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadCarga(carga) {
            this.carga = { ...carga }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        }
        this.loadCargas()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.cargas.length
    }
}
</script>

<style>
</style>
